import React from "react";
import cx from "clsx";
export var ItemTextContainer = function (_a) {
    var children = _a.children, isAlternative = _a.isAlternative, hasChip = _a.hasChip;
    var baseTextContainerClass = "flex flex-wrap justify-between w-full";
    var conditionalClasses = {
        "ml-4 max-w-50": isAlternative,
        "ml-2 max-w-10/12 sm:max-w-34 md:max-w-52": !isAlternative,
        "-mb-1": hasChip,
    };
    return React.createElement("div", { className: cx(baseTextContainerClass, conditionalClasses) }, children);
};
//# sourceMappingURL=ItemTextContainer.js.map